// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account__greetings i,.account__greetings svg{color:var(--success);margin-right:var(--spacer-1)}.account__logout{color:var(--text-muted);margin:var(--spacer-3) 0}.account__logout a{margin:0 var(--spacer-2);color:var(--danger)}.account__nav{margin-top:var(--spacer-5);display:flex;flex-wrap:nowrap;overflow-x:auto;overflow-y:hidden}.account__content{position:relative;padding-top:var(--spacer-5)}", ""]);
// Exports
module.exports = exports;
